function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11544",
  "data-name": "Path 11544",
  d: "M7.615,2.25a.865.865,0,0,1,.865.865v22.5a.865.865,0,0,1-1.731,0V3.115A.865.865,0,0,1,7.615,2.25Z",
  transform: "translate(-6.75 -2.25)",
  fill: "#ac1ede",
  fillRule: "evenodd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_11545",
  "data-name": "Path 11545",
  d: "M8.333,5.206c1.685-1.123,2.745-1.831,4.739-1.831a4.576,4.576,0,0,1,2.588.973l.055.038a3.053,3.053,0,0,0,1.684.72,3.03,3.03,0,0,0,1.016-.218q.521-.2,1.026-.433c.1-.047.2-.092.312-.138a8.867,8.867,0,0,1,3.7-.941.865.865,0,0,1,.865.865V14.624a.865.865,0,0,1-.865.865,7.207,7.207,0,0,0-3,.791l-.275.122c-.381.173-.784.355-1.174.5a4.706,4.706,0,0,1-1.608.322,4.576,4.576,0,0,1-2.588-.973l-.055-.038a3.054,3.054,0,0,0-1.684-.72c-1.441,0-2.108.425-3.847,1.585a.866.866,0,0,1-.891-1.485c1.685-1.124,2.745-1.831,4.739-1.831a4.576,4.576,0,0,1,2.588.973l.055.038a3.054,3.054,0,0,0,1.684.72,3.03,3.03,0,0,0,1.016-.218c.324-.118.651-.265,1.026-.433.1-.047.2-.092.312-.138a9.948,9.948,0,0,1,2.838-.886V5.18a8.959,8.959,0,0,0-2.135.716l-.275.122c-.381.173-.784.355-1.174.5a4.706,4.706,0,0,1-1.608.322,4.576,4.576,0,0,1-2.588-.973l-.055-.038a3.054,3.054,0,0,0-1.684-.72c-1.441,0-2.108.425-3.847,1.585a.865.865,0,0,1-.959-1.44l.069-.045Z",
  transform: "translate(-7.015 -2.51)",
  fill: "#ac1ede",
  fillRule: "evenodd"
});

var SvgGettingstarted = function SvgGettingstarted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gettingstarted",
    width: 17.307,
    height: 24.229,
    viewBox: "0 0 17.307 24.229",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGettingstarted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gettingstarted.9f632b03.svg";
export { ForwardRef as ReactComponent };